<template>
  <div>
    <div v-if="carregando == true" class="carregando">
      <img width="130px" :src="iconeCarregando" />
      <br />
      <br />Carregando...
    </div>
    <div class="box-interno ">
      <div class="mobile-margin visible-xs"></div>
      <div class="page-header clear-filter">
        <div>
          <h3 class="title">FAQ</h3>
        </div>
      </div>
      <div class="faq p-0 container">
        <div>
          <div class="row">
            <!--div class="col-sx-12 col-md-4">
            <card>
              <h4 class="h1-seo">
                <i class="now-ui-icons ui-2_chat-round mr-3"></i>Fale Conosco
              </h4>
              <br />
              <formFalecom @busca="buscarDados" :interno="true"></formFalecom>
            </card>
          </div-->
            <div id="Resultados" class="col-sx-12 col-md-12 p-2">
              <div class="perguntas  mt-3 p-4">
                <div class>
                  <h3 class="">Perguntas Frequentes</h3>
                  <alert v-if="perguntas.length == 0" type="warning"
                    >Nenhuma Pergunta Frequente encontrada!</alert
                  >
                  <collapse v-else class="text-left">
                    <collapse-item
                      v-for="(item, index) in perguntas"
                      :title="item.pergunta"
                      :indice="index + 1"
                      :key="item.id"
                      name="1"
                      class="card-item"
                    >
                      <div class="resposta">{{ item.resposta }}</div>
                    </collapse-item>
                  </collapse>
                </div>
              </div>

              <div class="mb-5"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Tabs,
  TabPane,
  Navbar,
  DropDown,
  Card,
  Collapse,
  CollapseItem,
  Alert,
} from '@/components';
import jwt from 'jsonwebtoken';
import moment from 'moment';
import service from './../services';
import storage from '../services/storage';
export default {
  name: 'profile',
  components: {
    Tabs,
    TabPane,
    Navbar,
    DropDown,
    Card,
    Collapse,
    CollapseItem,
    Alert,
  },
  data() {
    return {
      iconeCarregando: service.getEnvIconeCarregando(),
      carregando: false,
      decoded: {},
      filtro: {},
      perguntas: [],
    };
  },
  methods: {
    formataNota(nota) {
      var amarela = 'https://vetmark.s3.amazonaws.com/site/pegada-amarela.png';
      var cinza = 'https://vetmark.s3.amazonaws.com/site/pegada-cinza.png';

      if (!nota) nota = 5;
      else nota = parseInt(nota);
      var qtdAmarela = nota;
      var qtdCinza = 5 - nota;
      var str = '';
      for (let index = 0; index < qtdAmarela; index++) {
        str = str + `<img src="${amarela}">`;
      }
      for (let index = 0; index < qtdCinza; index++) {
        str = str + `<img src="${cinza}">`;
      }
      return str;
    },
    retornaidEmpresa() {
      const idEmpresa = storage.lerStorage('idEmpresa');
      return idEmpresa;
    },
    buscarDados() {
      this.carregando = true;

      service
        .getAll('Faq', {}, 'Listar/ativo?idEmpresa=' + this.retornaidEmpresa())
        .then(res => {
          this.perguntas = [];
          res.data.forEach(element => {
            this.perguntas.push(element);
          });
          console.log(this.perguntas);
          //this.$scrollTo("#Resultados");
          this.carregando = false;
        });
    },
  },
  mounted() {
    this.buscarDados();
  },
};
</script>
<style scoped>
.profile-page .page-header,
.page-header {
  min-height: auto !important;
  height: auto !important;
}

.profile-page .title {
  margin-top: 0px;
}
</style>

<style lang="scss">
.perguntas .card-collapse {
}
.perguntas .card-collapse .card-plain {
  padding: 10px;
}
.perguntas .card-item {
  border-radius: 10px;
  margin-bottom: 10px;
  .indice {
    padding: 5px 10px;
    margin-right: 10px;
    font-size: 16px;
  }
  .resposta {
    padding: 10px;
    margin-top: 10px;
  }
  a {
    font-size: 14px;
    font-weight: bold;
    &:hover {
      text-decoration: none;
    }
  }
}
.perguntas .estrelas {
  display: inline-table;
  margin-left: 10px;

  text-align: right;
}

.perguntas .estrelas img {
  width: 20px;
  margin-right: 5px;
}
.perguntas .card-header a i {
  float: right !important;
  color: #706f70;
}
.perguntas .card-collapse .card-plain:last-child {
  border-bottom: 0;
}
.perguntas .w-50 {
  display: inline-table;
  width: 40%;
}
.perguntas .w-40 {
  display: inline-table;
  width: 40%;
}
</style>
